/**
 * Phaser 게임 엔진 관련 에러
 * Phaser sounds/music stop playing in the new iOS 17.5.1 after losing/gaining focus in safari
 * Ref: https://github.com/phaserjs/phaser/issues/6829
 */
export const PHASER_ERROR_PATTERNS = [
  // https://zep-us.sentry.io/issues/4471272870
  'Failed to start the audio device',
  // Sentry Issue: https://zep-us.sentry.io/issues/4475874713
  'Unable to decode audio data',
  // Sentry Issue: https://zep-us.sentry.io/issues/4477062522
  'Decoding failed',

  /**
   * WebGL GPU/디바이스 렌더링 에러
   * - 사용자의 GPU 드라이버 버전, 디바이스 호환성 문제로 발생
   * - WebGL: INVALID_VALUE (texImage2D 등) - GPU 메모리 부족 또는 텍스처 크기 초과
   * - WebGL: INVALID_OPERATION - GPU가 해당 연산을 지원하지 않음
   * - CONTEXT_LOST_WEBGL - GPU 리소스가 OS에 의해 회수됨 (탭 전환, 메모리 부족)
   * - 앱 코드 문제가 아닌 클라이언트 환경 이슈
   * - play-app의 Phaser 게임 엔진에서 주로 발생 (2D 캔버스 렌더링)
   *
   * Added: 2026-02-22 주간 Sentry 노이즈 리포트
   *
   * ⚠️ 필터 해제 검토 기준:
   * - WebGL 에러가 특정 Phaser 버전 업데이트 후 급증하면 앱 코드 문제일 수 있음
   * - Users > 1,000인 Vertex Shader/Framebuffer 에러는 REVIEW로 분류됨 (이 필터에 포함 안 됨)
   *
   * Sentry Issues:
   * - https://zep-us.sentry.io/issues/PLAY-APP-8K1 (6,086 users, WebGL: INVALID_VALUE: texImage2D)
   * - https://zep-us.sentry.io/issues/PLAY-APP-96V (913 users, WebGL: INVALID_OPERATION)
   * - https://zep-us.sentry.io/issues/PLAY-APP-8JS (1,522 users, CONTEXT_LOST_WEBGL)
   * - https://zep-us.sentry.io/issues/PLAY-APP-53K (547 users, WebGL: INVALID_VALUE)
   */
  /WebGL: INVALID_/,
  'CONTEXT_LOST_WEBGL',
] as const;
